import s from './style.css';
import { Component } from 'preact';
import cn from 'classnames';
import NextArrow from 'components/NextArrow';

class Section extends Component {
	componentWillUnMount() {
		const { observer } = this.props;
		observer.unobserve(this.elem);
	}

	componentDidMount() {
		const { observer } = this.props;
		observer.observe(this.elem);
	}

	shouldComponentUpdate(nextProps) {
		return nextProps.isVisible !== this.props.isVisible;
	}

	render() {
		const { copy, id, override, isLast, isVisible } = this.props;
		const next = isLast ? 'it-might-not-work-out' : `section-${id + 1}`;

		const main = copy();

		return (
			<div
				className={cn(s.extra, {
					[s.isVisible]: isVisible
				})}
			>
				<div className={s.wrapper} id={`section-${id}`}>
					<div
						className={cn(s.root, {
							[s.override]: override
						})}
						id={id}
						ref={elem => (this.elem = elem)}
					>
						<div>{main}</div>
						<p className={s.next}>
							<NextArrow to={`${next}`} />
						</p>
					</div>
				</div>
			</div>
		);
	}
}

export default Section;



// WEBPACK FOOTER //
// ./components/RomanceBreakdownViz/Section/index.js